// extracted by mini-css-extract-plugin
export default {"selectMultiple__icon":"SelectMultipleDropdownNew_selectMultiple__icon__B2An3","selectMultiple__chipList":"SelectMultipleDropdownNew_selectMultiple__chipList__DKd-G"};